export { default } from "./DetectLocation";
